module.exports = __webpack_public_path__ + "img/0c819ff.png";